var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF; opacity:0.75}\n\t.st1{fill:#000000;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "container",
    className: "st0",
    cx: 24,
    cy: 24,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    className: "st1",
    d: "M19.8,25l5.6,5.6L24,32l-8-8l8-8l1.4,1.4L19.8,23H32v2H19.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.d840730d58dfb0e62eda0009094b3db8.svg";
export { ForwardRef as ReactComponent };